module.exports = __webpack_public_path__ + "img/chengcon2.9e43c446.jpg";